module.exports = __webpack_public_path__ + "img/loading-linza.fc99a9e.gif?v=1745396668212";